<template>
  <div
    class="float-right copy-link"
    style="position: sticky; top: 0; right: 0"
  >
    <span
      v-if="tableTextSwitcher.show === 'text'"
      @click="copyTable"
    >
      Скопировать таблицу
    </span>

    <button
      class="btn btn-primary config-btn-primary btn-sm ml-2 mt-1"
      style="min-width: 210px"
      @click="toggleTableText"
    >
      {{ tableTextSwitcher.text }}
    </button>

    <div
      v-if="tableTextSwitcher.show === 'text'"
      class="pt-2"
    >
      <ui-pagination
        :page-number="pageNumber"
        :pages-length="pagesLength"
        @changeValue="setPage"
      />
    </div>
  </div>
  <table
    v-if="tableTextSwitcher.show === 'table'"
    class="table-simple excel-bottom-indent"
  >
    <caption class="caption-top">
      Таблица по критическим нарушениям
    </caption>
    <tbody>
      <tr
        v-for="obj in props.objects"
        style="border: 1px solid #000"
      >
        <th
          data-excelalignh="center"
          v-html="obj.avtoNo"
        ></th>
        <td data-excelalignh="center">
          <template v-for="violation in obj.roughlyViolations">
            <div
              v-if="violation.DForfeits > 0"
              class="flex violations-table__item"
            >
              <div>{{ violation.DSkill }}</div>
              <div style="width: 100px; text-align: center">
                {{ violation.DForfeits }}
              </div>
            </div>
          </template>
        </td>
      </tr>
    </tbody>
  </table>

  <div id="for-copy"></div>

  <the-toaster ref="toaster" />
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from 'vue';
import TheToaster from '@/App/Components/toaster/TheToaster.vue';
import UiPagination from '@/App/Components/UiPagination.vue';

const toaster = ref(null);

const props = defineProps({
  title: { type: String, required: true },
  objects: { type: Array, required: true },
});

const emit = defineEmits([]);

const tableTextSwitcher = ref({
  show: 'table',
  text: 'Открыть текст для копирования',
});

const pageNumber = ref(-1);
const pagesLength = ref(0);

const pagesTextArray = ref([]);

onBeforeUnmount(() => {
  document.getElementById('for-copy').innerHTML = '';
});

const toggleTableText = () => {
  if (tableTextSwitcher.value.show === 'table') {
    tableTextSwitcher.value.show = 'text';
    tableTextSwitcher.value.text = 'Открыть таблицу';
    setPagesTextArray();
    setPage(0);
  } else {
    tableTextSwitcher.value.show = 'table';
    tableTextSwitcher.value.text = 'Открыть текст для копирования';
    document.getElementById('for-copy').innerHTML = '';
  }
};

const setPagesTextArray = () => {
  let pageIndex = 0;
  pagesTextArray.value = props.objects.reduce(
    (acc, obj, index) => {
      const commitedViolations = obj.roughlyViolations.filter(
        (violation) => violation.DForfeits > 0,
      );

      const violationsHtml = commitedViolations.reduce(
        (acc, violation, index) => {
          acc += `${violation.DSkill} - ${violation.DForfeits}`;

          if (index < commitedViolations.length - 1) {
            acc += ', </br>';
          } else {
            acc += '; </br>';
          }

          return acc;
        },
        '',
      );

      if (obj.roughlyViolationsCount > 0) {
        const newStringWithObjectViolations = `${obj.avtoNo}: </br>${violationsHtml} </br>`;

        if (
          acc[pageIndex].length + newStringWithObjectViolations.length >=
          4096
        ) {
          pageIndex++;
          acc[pageIndex] = '';
        }

        acc[pageIndex] += newStringWithObjectViolations;
      }

      return acc;
    },
    [`${props.title}</br></br>`],
  );

  pagesLength.value = pagesTextArray.value.length;
};

const setPage = (index) => {
  document.getElementById('for-copy').innerHTML = pagesTextArray.value[index];
  pageNumber.value = index;
};

const copyTable = async () => {
  const htmlForCopy = document.getElementById('for-copy');

  copyWithStyle(htmlForCopy);
  toaster.value.success({ message: 'Текст успешно скопирован', delay: 2000 });
};

const copyWithStyle = (element) => {
  const doc = document;
  let range;
  let selection;

  if (doc.body.createTextRange) {
    range = doc.body.createTextRange();
    range.moveToElement(element);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();

    range = doc.createRange();
    range.selectNodeContents(element);

    selection.removeAllRanges();
    selection.addRange(range);
  }

  document.execCommand('copy');
  window.getSelection().removeAllRanges();
};
</script>

<style lang="scss" scoped>
.copy-link {
  cursor: pointer;

  &:hover {
    color: #4a5156;
  }
}
.violations-table__item {
  justify-content: space-between;
  border-bottom: 1px solid #ccc;

  &:last-child {
    border-bottom: none;
  }
}
</style>
